/**
 * Hard-coded tag ids in the database.
 */
export enum Tag {
  APPRECIATION_FOCUSED = '0cb0e9fb-56c0-443b-a9a6-38f338ce70a4',
  BALANCED = '7f78f249-bfcd-4521-8c4c-6328202816df',
  DIVIDEND_FOCUSED = 'f6cb9f13-6fcf-4978-83a8-9638f1d6708f',
  GREAT_SCHOOLS = '6bc13469-83dc-405d-98fc-e22db95cb7e6',
}
